(function () {
  'use strict';

  if (window.FellinoraBenefitShowcaseStaticLoaded) {
    return;
  }

  window.FellinoraBenefitShowcaseStaticLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.documentElement.classList.add('fbss-js');

  function setRevealDelays(section) {
    var lines = section.querySelectorAll('[data-fbss-line]');
    var revealItems = section.querySelectorAll('[data-fbss-reveal]');

    lines.forEach(function (line, index) {
      line.style.setProperty('--fbss-delay', 120 + index * 110 + 'ms');
    });

    revealItems.forEach(function (item, index) {
      item.style.setProperty('--fbss-delay', Math.min(index * 120, 620) + 'ms');
    });
  }

  function initReveal(section) {
    setRevealDelays(section);

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      section.classList.add('fbss-is-visible');
      section.querySelectorAll('[data-fbss-reveal]').forEach(function (item) {
        item.classList.add('fbss-is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.add('fbss-is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.16,
      rootMargin: '0px 0px -8% 0px'
    });

    section.querySelectorAll('[data-fbss-reveal]').forEach(function (item) {
      observer.observe(item);
    });
  }

  function initSection(section) {
    initReveal(section);
  }

  function init() {
    document.querySelectorAll('[data-fbss-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.matches('[data-fbss-section]') ? event.target : event.target.querySelector('[data-fbss-section]');

    if (section) {
      initSection(section);
    }
  });
})();
